"use client";

import { useModal } from "@/components/providers/modal-provider";
import { modalIds } from "./constants";

const QUIZ_MODAL_IDS = new Set([
  modalIds.quiz,
  modalIds.quizQuestionnaire,
  modalIds.quizExit,
]);

export function QuizBackdrop() {
  const { modalId } = useModal();
  const isVisible = QUIZ_MODAL_IDS.has(modalId);

  return (
    <div
      aria-hidden
      className="fixed inset-0 z-[51] bg-black/[0.08] backdrop-blur-[80px] transition-opacity duration-200 pointer-events-none"
      style={{ opacity: isVisible ? 1 : 0, visibility: isVisible ? "visible" : "hidden" }}
    />
  );
}
